import { useMutation, useQueryClient } from '@tanstack/react-query';

import { patchUser } from '@arrived/api_v2';
import { User, UserRequest } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { currentUserKeyFn } from './users.keys';

export function usePatchUserMutation(options?: UseMutationOptions<User, UserRequest>) {
  const queryClient = useQueryClient();

  return useMutation((userRequest) => patchUser(userRequest), {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.setQueryData(currentUserKeyFn(), data);

      queryClient.invalidateQueries(currentUserKeyFn());

      options?.onSuccess?.(data, variables, context);
    },
  });
}
